module.exports = "https://milano-network.servercdn.it/static/img/checked.svg?dac2c2637fb53d051e9a399947614bac";